import React from "react";
import { Box, Text } from "@ui-kit/components/index.es";

import I18n from "pages/_components/I18n";

function PrivacyPolicyV3Content() {
    return (
        <Box column gap={24} w="100%" css={{ maxHeight: "50vh", overflowY: "auto" }}>
            <Text
                as="h2"
                variant="body"
                color="white"
                css={{ fontSize: 20, fontFamily: "inherit" }}
                componentProps={{ "data-testid": "privacy-title" }}>
                <I18n id="global.privacy" />
            </Text>
            <Text variant="body" color="white" component="p">
                <I18n id="global.privacy.message" componentProps={{ className: "text-white" }} />
            </Text>
        </Box>
    );
}

export default PrivacyPolicyV3Content;
